import AbstractBaseApi from "@/apis/AbstractBaseApi";

/** ヘルスチェックAPI */
export default class HealthCheckApi extends AbstractBaseApi {
  async healthCheck(): Promise<void> {
    await this.api.get("/healthcheck");
  }
}
